import { render, staticRenderFns } from "./SetPwd.vue?vue&type=template&id=9281de94"
import script from "./SetPwd.vue?vue&type=script&lang=js"
export * from "./SetPwd.vue?vue&type=script&lang=js"
import style0 from "./SetPwd.vue?vue&type=style&index=0&id=9281de94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports